// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d5f0d2bf","667":"ac296326","977":"d6ca5d06"}[chunkId] + ".chunk.js";
};